/**
 * Create Advanced Filter Active Search Term web component.
 * Use this component to render Advanced Filter Active Search Term element
 */
class SHTAdvancedFilterActiveSearchTerm extends HTMLElement {
  /**
   * constructor
   */
  constructor() {
    super();
    this.elms = {
      search_term: this.querySelector(`[data-type="search-term-item"]`),
    };
    this.bindEventHandlers();
  }

  /**
   * bind event handler to web component elements
   */
  bindEventHandlers() {
    this.elms.search_term.addEventListener(
      "click",
      this.onActiveSearchTermClickHandle.bind(this)
    );
  }
  /**
   * Handle on search term click event
   * @param Event e
   */
  onActiveSearchTermClickHandle(e) {
    e.preventDefault();
    let form =
      this.closest("sht-advanced-filter") ||
      document.querySelector("sht-advanced-filter");
    form.onActiveSearchTermClickHandle(e);
  }
}

// Register to the Browser from `customElements` API
customElements.define(
  "sht-advanced-filter-active-search-term",
  SHTAdvancedFilterActiveSearchTerm
);
